import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SLUGS from 'resources/routesConstants';
import { LayoutDashboard, User, Shield, ShieldCheck, CircleDollarSign, Headphones, ShoppingCart, Wallet, Receipt, BadgeCheck, Building2, MessageSquare, Package, Bell, Palette, IdCard } from 'lucide-react';
import { convertSlugToUrl } from 'resources/utilities';
import Menu from './MenuComponent';
import MenuItem from './MenuItemComponent';
import { useAuthStore } from '@/stores/auth-store';
import useWindowSize from '@/hooks/useWindowSize';

// Lucide icon wrapper to match the MUI icon component API expected by MenuItem
const icon = (Icon) => (props) => <Icon size={20} {...props} />;
const DashboardIcon = icon(LayoutDashboard);
const PersonIcon = icon(User);
const SecurityIcon = icon(Shield);
const VerifiedUserIcon = icon(ShieldCheck);
const MonetizationOnIcon = icon(CircleDollarSign);
const SupportAgentIcon = icon(Headphones);
const LocalGroceryStoreIcon = icon(ShoppingCart);
const AccountBalanceWalletIcon = icon(Wallet);
const ReceiptLongIcon = icon(Receipt);
const OrdersIcon = icon(Package);
const VerifiedIcon = icon(BadgeCheck);
const HealthSystemsIcon = icon(Building2);
const MessagesIcon = icon(MessageSquare);
const NotificationsIcon = icon(Bell);
const DisplayIcon = icon(Palette);
const HealthIdIcon = icon(IdCard);



function SidebarComponent() {
    const userRole = useAuthStore((s) => s.getUserRolesAsNumbers)();
    const isClinician = useAuthStore((s) => s.isClinician)();
    // MYID-D6a — translated nav labels. Keys live in src/locales/<lang>/nav.json.
    const { t } = useTranslation('nav');

    const navigate = useNavigate();
    // MYID-H9 — was `window.innerWidth <= 1080` computed once at render;
    // wouldn't re-evaluate on resize so a phone rotated landscape /
    // desktop window resized got stuck in the wrong mode. useWindowSize
    // tracks both dims and re-renders on resize.
    const [width] = useWindowSize();
    const isMobile = width > 0 && width <= 1080;

    function onClick(slug, parameters = {}) {
        navigate(convertSlugToUrl(slug, parameters));
    }

    return (
        <Menu isMobile={isMobile}>
            <div style={{ height: 16 }} />
            <MenuItem
                id={SLUGS.dashboard}
                title={t('sidebar.overview')}
                icon={DashboardIcon}
                onClick={() => onClick(SLUGS.dashboard)}
            />

            <MenuItem
                id={SLUGS.profile}
                title={t('sidebar.profile')}
                icon={PersonIcon}
                onClick={() => onClick(SLUGS.profile)}
            />
             <MenuItem
                id={SLUGS.security}
                title={t('sidebar.security')}
                icon={SecurityIcon}
                onClick={() => onClick(SLUGS.security)}
            />
             <MenuItem
                id={SLUGS.licenses}
                title={t('sidebar.licenses')}
                icon={VerifiedUserIcon}
                onClick={() => onClick(SLUGS.licenses)}
            />
            <MenuItem
                id={SLUGS.healthSystems}
                title={t('sidebar.healthSystems')}
                icon={HealthSystemsIcon}
                onClick={() => onClick(SLUGS.healthSystems)}
            />
            <MenuItem
                id={SLUGS.abha}
                title={t('sidebar.abha', 'ABHA / Health ID')}
                icon={HealthIdIcon}
                onClick={() => onClick(SLUGS.abha)}
            />
            {isClinician &&
             <MenuItem
                id={SLUGS.hpr}
                title={t('sidebar.hpr', 'HPR / Professional ID')}
                icon={VerifiedIcon}
                onClick={() => onClick(SLUGS.hpr)}
            />
            }
            {userRole?.includes(13) &&
             <MenuItem
                id={SLUGS.subscriptions}
                title={t('sidebar.store')}
                icon={LocalGroceryStoreIcon}
                onClick={() => onClick(SLUGS.subscriptions)}
            />
            }
            <MenuItem
                id={SLUGS.subscriptions}
                title={t('sidebar.subscriptions')}
                icon={MonetizationOnIcon}
                onClick={() => onClick(SLUGS.subscriptions)}
            />

            <MenuItem
                id={SLUGS.credits}
                title={t('sidebar.credits')}
                icon={AccountBalanceWalletIcon}
                onClick={() => onClick(SLUGS.credits)}
            />
            <MenuItem
                id={SLUGS.purchaseHistory}
                title={t('sidebar.purchases')}
                icon={ReceiptLongIcon}
                onClick={() => onClick(SLUGS.purchaseHistory)}
            />
            <MenuItem
                id={SLUGS.orders}
                title={t('sidebar.orders')}
                icon={OrdersIcon}
                onClick={() => onClick(SLUGS.orders)}
            />
            <MenuItem
                id={SLUGS.verification}
                title={t('sidebar.verification')}
                icon={VerifiedIcon}
                onClick={() => onClick(SLUGS.verification)}
            />
            <MenuItem
                id={SLUGS.messages}
                title={t('sidebar.messages')}
                icon={MessagesIcon}
                onClick={() => onClick(SLUGS.messages)}
            />
            {/* DSC-1A.2 + 1B.2 prefs pages — were route-only, unreachable from nav
                until MYID-C added these entries 2026-05-24. */}
            <MenuItem
                id={SLUGS.notificationPrefs}
                title={t('sidebar.notifications')}
                icon={NotificationsIcon}
                onClick={() => onClick(SLUGS.notificationPrefs)}
            />
            <MenuItem
                id={SLUGS.accountDisplayPrefs}
                title={t('sidebar.display')}
                icon={DisplayIcon}
                onClick={() => onClick(SLUGS.accountDisplayPrefs)}
            />
            <MenuItem
                id={SLUGS.support}
                title={t('sidebar.support')}
                icon={SupportAgentIcon}
                onClick={() => onClick(SLUGS.support)}
            />
        </Menu>

    );
}

export default SidebarComponent;

